import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-illustration">
          {/* Add hero image here */}
          <img
            src="/hero_arrows.png"
            alt="Career pathway arrows"
            className="hero-illustration-img"
          />
        </div>

        <div className="hero-content">
          <h1 className="hero-title">
            Clarity, Direction, & Informed Decisions after Class 12
          </h1>
          <p className="hero-subtitle">
            An Integrated Career & College Intelligence Platform for Students, Parents, and Institutions
          </p>
          <div className="hero-cta-group">
            <button className="btn btn-primary">For Students & Parents</button>
            <button className="btn btn-secondary">For Institutions</button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="hero-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
    </section>
  );
};

export default Hero;
